import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { TestsComponent } from './menupoints/tests/tests.component';

export const appRoutes: Route[] = [
	{ path: '', redirectTo: '/tests', pathMatch: 'full' },
	{ path: 'tests', component: TestsComponent, canActivate: [MsalGuard] },
];
